// extracted by mini-css-extract-plugin
export default {"main":"Home_main__3ilkD","tabsContainer":"Home_tabsContainer__IJOQC"};